<template>
  <div>
    <section class="mb-4 pt-4">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 text-lg-left text-center">
            <h1 class="fw-600 h4">{{ $t("所有品牌") }}</h1>
          </div>
          <div class="col-lg-6">
            <ul
              class="breadcrumb justify-content-center justify-content-lg-end bg-transparent p-0"
            >
              <li class="breadcrumb-item opacity-50">
                <a class="text-reset" href="javascript:void(0)">{{
                  $t("首页")
                }}</a>
              </li>
              <li class="text-dark fw-600 breadcrumb-item">
                <a class="text-reset" href="javascript:void(0)">{{
                  $t("所有品牌")
                }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="mb-4">
      <div class="container">
        <div class="rounded bg-white px-3 pt-3 shadow-sm">
          <div
            class="row row-cols-xxl-6 row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-2 gutters-10"
          >
            <div
              v-for="(item, index) in brands"
              :key="index"
              class="col text-center"
            >
              <router-link
                class="d-block border-light hov-shadow-md mb-3 rounded border p-3"
                :to="`/brand?brandCode=${item.code}&brandName=${item.name}`"
              >
                <img
                  :src="getFileViewUrl(item.pic)"
                  alt
                  class="h-70px mw-100 mx-auto ls-is-cached lazyloaded"
                />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { getBrandList } from "@/api/storeBrand";

export default {
  data() {
    return { brands: [] };
  },
  created() {
    this.getBrands();
  },
  methods: {
    async getBrands() {
      const res = await getBrandList();
      this.brands = res.data.map(item => {
        item.to = "/brands";
        return item;
      });
    }
  }
};
</script>
